import { HG_BASE_PATH, IS24_BASE_PATH } from '@/router/routes/constants';

import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import type { Article, ArticleImageSrcset } from '@/stores/types/landing';

export interface DisplayableArticle {
  title: string;
  text: string;
  href: string;
  linkText: string;
  img: {
    src: string;
    srcset: string;
    alt: string;
    title: string;
  };
}

const fullUrl = (path: string) =>
  isPlatformIs24() ? `${IS24_BASE_PATH}${path}` : `${HG_BASE_PATH}${path}`;

const mapSrcset = (srcsets: ArticleImageSrcset[]): string =>
  srcsets.map((s) => `${fullUrl(s.src)} ${s.media}`).join(',');

const adaptData = (articles: Article[]): DisplayableArticle[] =>
  articles.map(({ title, text, link, img }: Article) => ({
    title,
    text,
    href: fullUrl(link.href),
    linkText: link.text,
    img: {
      src: img ? fullUrl(img.original) : '',
      srcset: img ? mapSrcset(img.srcset) : '',
      alt: img?.alt ?? '',
      title: img?.title ?? '',
    },
  }));

export default adaptData;
